// extracted by mini-css-extract-plugin
export var mosaic = "homeProduct-module--mosaic--J984L";